
    <template>
      <section class="content element-doc">
        <h2 id="geng-duo-an-niu"><a class="header-anchor" href="#geng-duo-an-niu">¶</a> 更多按钮</h2>
<p>继承自 el-button 的属性</p>
<h3 id="ji-chu-yong-fa"><a class="header-anchor" href="#ji-chu-yong-fa">¶</a> 基础用法</h3>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div class=&quot;sh-more-button-demo&quot;&gt;
    &lt;el-input /&gt;
    &lt;ShMoreButton @search=&quot;onSearch&quot; :width=&quot;500&quot; icon=&quot;el-icon-search&quot;&gt;
      &lt;div&gt;
        &lt;el-row :gutter=&quot;16&quot;&gt;
          &lt;el-col :span=&quot;12&quot;&gt;
            &lt;el-input&gt;&lt;/el-input&gt;
          &lt;/el-col&gt;
          &lt;el-col :span=&quot;12&quot;&gt;
            &lt;el-input&gt;&lt;/el-input&gt;
          &lt;/el-col&gt;
        &lt;/el-row&gt;
      &lt;/div&gt;
    &lt;/ShMoreButton&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
  export default {
    methods: {
      onSearch() {
        console.log('onSearch')
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h3 id="attributes"><a class="header-anchor" href="#attributes">¶</a> Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>width</td>
<td>容器宽度</td>
<td>number,string</td>
<td>'300px'</td>
</tr>
<tr>
<td>text</td>
<td>按钮文字</td>
<td>String</td>
<td>查询</td>
</tr>
</tbody>
</table>
<h3 id="events"><a class="header-anchor" href="#events">¶</a> Events</h3>
<table>
<thead>
<tr>
<th>事件名称</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>search</td>
<td>搜索事件</td>
<td>-</td>
</tr>
</tbody>
</table>
<h3 id="slot"><a class="header-anchor" href="#slot">¶</a> Slot</h3>
<table>
<thead>
<tr>
<th>名称</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>-</td>
<td>更多搜索条件</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',{staticClass:"sh-more-button-demo"},[_c('el-input'),_vm._v(" "),_c('ShMoreButton',{attrs:{"width":500,"icon":"el-icon-search"},on:{"search":_vm.onSearch}},[_c('div',[_c('el-row',{attrs:{"gutter":16}},[_c('el-col',{attrs:{"span":12}},[_c('el-input')],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-input')],1)],1)],1)])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
    methods: {
      onSearch() {
        console.log('onSearch')
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  